import theme from "./theme";
import variant from "./variant";
import backgrounds from "../theme/backgrounds";
export const background = variant("mode", "background", backgrounds);
export const clipBackground = theme("mode", backgrounds.clip);
export const defaultBackground = theme("mode", backgrounds.default);
export const primaryBackground = theme("mode", backgrounds.primary);
export const selectedBackground = theme("mode", backgrounds.selected);
export const secondaryBackground = theme("mode", backgrounds.secondary);
export const selectionBackground = theme("mode", backgrounds.selection);
export default background;
//# sourceMappingURL=background.js.map